module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "22",
      "height": "20",
      "viewBox": "0 0 22 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.418 16.825C11.7999 16.9419 11.1721 17.0005 10.543 17C6.065 17 2.275 14.057 1 10C1.34327 8.9081 1.87199 7.88346 2.563 6.971M8.421 7.879C8.98366 7.31634 9.74678 7.00025 10.5425 7.00025C11.3382 7.00025 12.1013 7.31634 12.664 7.879C13.2267 8.44166 13.5428 9.20478 13.5428 10.0005C13.5428 10.7962 13.2267 11.5593 12.664 12.122M8.421 7.879L12.664 12.122M8.421 7.879L12.663 12.12M12.664 12.122L15.955 15.412M8.423 7.88L5.133 4.59M5.133 4.59L1.543 1M5.133 4.59C6.74536 3.54957 8.6241 2.9974 10.543 3C15.021 3 18.811 5.943 20.086 10C19.382 12.2305 17.9204 14.1446 15.954 15.411M5.133 4.59L15.954 15.411M15.954 15.411L19.543 19",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be69046e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/closed_eye.vue
// module id = 46bd64fe6d7d2da21299
// module chunks = 89